import { Logo } from '../components/Logo';
import { useNavigate } from '../router';

/**
 * Alan adına giren kişinin gördüğü ilk sayfa.
 *
 * Doğrudan giriş formu açmak iki şeyi birden yapıyordu: tanımadığı bir siteye gelen
 * kişiden parola istiyor, ve buranın ne olduğunu hiç söylemiyordu. Form artık kendi
 * yolunda (`#/giris`) — panele gitmek isteyen bir tık daha atıyor, ama ne olduğunu
 * bilerek atıyor.
 *
 * Kasten sade: bu bir pazarlama sayfası değil, bir kapı. Süslemek, olmayan bir ürünü
 * varmış gibi göstermek olurdu.
 */
export function Landing() {
  const navigate = useNavigate();

  return (
    <main className="landing">
      <div className="landing-card">
        <Logo id="logo-landing" />

        <h1 className="landing-title">Veri toplama platformu</h1>
        <p className="landing-lede">
          Rab-bit kaynakları tarar, çıktısını tekilleştirir ve tüketen sistemlere düzenli
          bir veri kümesi olarak verir. Actor'lar bağımsız çalışır; platform hiçbirinin ne
          topladığını bilmez.
        </p>

        <button type="button" onClick={() => navigate('/giris')}>
          Panele gir
        </button>

        <p className="landing-foot">Kapalı bir platform. Erişim hesap gerektirir.</p>
      </div>
    </main>
  );
}
